import React from 'react'

import { Button } from '@insquad/tools'

import {
  EnumTypographyVariants,
  Typography,
} from 'src/common/components/Typography/Typography'
import { useAuthRedirect } from 'src/common/hooks/useAuthRedirect'
import { AnalyticEventEnum } from 'src/utils/analytic/analyticEventEnum'
import { useAnalytic } from 'src/utils/analytic/useAnalytic'

import s from './ResumeCardEmpty.module.scss'

export type ResumeCardEmptyProps = {
  publicName: string
  developersCount: number
}

export const ResumeCardEmpty: React.FC<ResumeCardEmptyProps> = ({
  publicName,
  developersCount,
}) => {
  const { analytic } = useAnalytic()
  const { handleSignUpRedirect } = useAuthRedirect()

  const handleSignUp = () => {
    analytic.event(AnalyticEventEnum.SIGN_UP, {
      page: 'domain or skill',
      from: 'profiles',
    })

    handleSignUpRedirect()
  }

  return (
    <div className={s.ResumeCardEmpty}>
      <Typography
        variant={EnumTypographyVariants.H4}
        className={s.ResumeCardEmpty__title}
      >
        {`Sign up to get access to ${developersCount} `}
        <span>{publicName}</span>
        {' developers profiles'}
      </Typography>

      <Button onClick={handleSignUp}>Sing Up</Button>
    </div>
  )
}
